import { z } from 'zod';

export const DocSourceNameSchema = z
  .string()
  .regex(
    /^[a-z0-9](?:[a-z0-9-]{0,30}[a-z0-9])?$/,
    'expected a lower-case source name such as "help"',
  )
  .brand<'DocSourceName'>();
export type DocSourceName = z.infer<typeof DocSourceNameSchema>;

export const DocSourceKindSchema = z.enum(['zendesk']);
export type DocSourceKind = z.infer<typeof DocSourceKindSchema>;

export const DOC_SOURCE_DESCRIPTION_MAX_CHARS = 300;

export const SEARCH_DOCS_MAX_RESULTS = 8;

export const FETCH_DOC_MAX_CHARS = 40_000;

export const SearchDocsInputSchema = z.object({
  query: z.string().trim().min(1).max(500),
  source: z.string().optional(),
});
export type SearchDocsInput = z.infer<typeof SearchDocsInputSchema>;

export const FetchDocInputSchema = z.object({
  source: z.string(),
  id: z.string().min(1).max(256),
  offset: z.number().int().nonnegative().optional(),
});
export type FetchDocInput = z.infer<typeof FetchDocInputSchema>;

export const DocSearchHitSchema = z.object({
  source: z.string(),
  id: z.string(),
  title: z.string(),
  url: z.string(),
  snippet: z.string(),
});
export type DocSearchHit = z.infer<typeof DocSearchHitSchema>;

export const DOCS_ERROR_CODES = [
  'invalid_tool_input',
  'unknown_source',
  'not_found',
  'unavailable',
] as const;
export type DocsErrorCode = (typeof DOCS_ERROR_CODES)[number];

const DocsToolErrorSchema = z.object({
  type: z.literal('docs_tool_error'),
  error_code: z.enum(DOCS_ERROR_CODES),
  message: z.string(),
});
export type DocsToolError = z.infer<typeof DocsToolErrorSchema>;

export const SearchDocsOutputSchema = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('search_docs_result'),
    results: z.array(DocSearchHitSchema),
  }),
  DocsToolErrorSchema,
]);
export type SearchDocsOutput = z.infer<typeof SearchDocsOutputSchema>;

export const FetchDocOutputSchema = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('fetch_doc_result'),
    source: z.string(),
    id: z.string(),
    title: z.string(),
    url: z.string(),
    updated_at: z.string().nullable(),
    content: z.string(),
    offset: z.number().int().nonnegative(),
    total_chars: z.number().int().nonnegative(),
    next_offset: z.number().int().nonnegative().nullable(),
  }),
  DocsToolErrorSchema,
]);
export type FetchDocOutput = z.infer<typeof FetchDocOutputSchema>;
